import React from "react";
import { IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";

import {
  FILTROS,
  getDescriptor,
  opcionesDeCampo,
} from "./filter-registry";

/**
 * Una condición: campo + operador (incluir/excluir) + valores.
 * El control de valores lo determina el descriptor del campo en el registro.
 */
const CondicionEditor = ({ condicion, onChange, onRemove, opcionesApi }) => {
  const descriptor = getDescriptor(condicion.campo);
  const opciones = opcionesDeCampo(descriptor, opcionesApi);
  const esBooleano = descriptor?.control === "boolean";

  const handleCampo = (campo) => {
    // Los valores no son intercambiables entre campos, así que se reinician.
    onChange({ ...condicion, campo, valores: [] });
  };

  const valoresSeleccionados = opciones.filter((opcion) =>
    (condicion.valores ?? []).includes(opcion.value)
  );

  return (
    <div className="d-flex flex-wrap align-items-start mb-2">
      <TextField
        select
        label="Campo"
        value={condicion.campo}
        onChange={(e) => handleCampo(e.target.value)}
        variant="outlined"
        size="small"
        className="mr-2 mb-2"
        style={{ width: "220px", fontFamily: "'Noto Sans JP', sans-serif" }}
      >
        {FILTROS.map((filtro) => (
          <MenuItem key={filtro.campo} value={filtro.campo}>
            {filtro.label}
          </MenuItem>
        ))}
      </TextField>

      {!esBooleano && (
        <TextField
          select
          label="Operador"
          value={condicion.operador ?? "incluir"}
          onChange={(e) => onChange({ ...condicion, operador: e.target.value })}
          variant="outlined"
          size="small"
          className="mr-2 mb-2"
          style={{ width: "140px", fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          <MenuItem value="incluir">Incluir</MenuItem>
          <MenuItem value="excluir">Excluir</MenuItem>
        </TextField>
      )}

      {esBooleano ? (
        <TextField
          select
          label="Valor"
          value={condicion.valores?.[0] ?? "1"}
          onChange={(e) => onChange({ ...condicion, valores: [e.target.value] })}
          variant="outlined"
          size="small"
          className="mr-2 mb-2"
          style={{ width: "260px", fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          {opciones.map((opcion) => (
            <MenuItem key={opcion.value} value={opcion.value}>
              {opcion.label}
            </MenuItem>
          ))}
        </TextField>
      ) : (
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={opciones}
          getOptionLabel={(opcion) => opcion.label}
          getOptionSelected={(opcion, valor) => opcion.value === valor.value}
          value={valoresSeleccionados}
          onChange={(_, seleccion) =>
            onChange({
              ...condicion,
              valores: seleccion.map((opcion) => opcion.value),
            })
          }
          noOptionsText="Sin resultados"
          className="mr-2 mb-2"
          style={{ width: "380px" }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Valores"
              variant="outlined"
              size="small"
              placeholder="Selecciona uno o más"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            />
          )}
        />
      )}

      <Tooltip title="Quitar condición">
        <IconButton size="small" className="mt-1" onClick={onRemove}>
          <DeleteIcon style={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default CondicionEditor;
